import React from 'react'
import { Box, FormLabel, MenuItem, Select, TextField } from '@mui/material'
import PropTypes from 'prop-types'

// commented for deployment
import {
  CUSTOMER_ROLE_OPTIONS,
  EXTERNAL_VENDOR_OPTIONS,
  OPS_ROLE_OPTIONS
} from '../../../constants'

/**
 * TODO: complete update and view flow
 * insert
 */

export default function AccountForm({ formik, updateSelected }) {
  // get session type and check if user has auth permissions to set admin

  const handleRoleChange = (e) => {
    formik.setFieldValue('role', e.target.value)
  }

  const handleVendorChange = (e) => {
    formik.setFieldValue('vendor', e.target.value)
  }

  // put buttons to handle submission
  return (
    <Box sx={{ dispay: 'flex', direction: 'row' }}>
      <Box
        sx={{
          display: 'flex',
          width: '100%',
          direction: 'column',
          margin: '24px 0'
        }}
      >
        <Box sx={{ width: '100%' }}>
          <FormLabel sx={{ marginBottom: 0 }}>Name</FormLabel>
          <TextField
            id='contactName'
            name='contactName'
            display='border-box'
            sx={{ marginTop: '10px', width: '95%' }}
            variant='standard'
            onChange={(e) => {
              formik.handleBlur(e)
              formik.handleChange(e)
            }}
            value={formik.values.contactName}
            error={
              formik.touched.contactName && Boolean(formik.errors.contactName)
            }
            helperText={formik.touched.contactName && formik.errors.contactName}
            disabled={Boolean(!updateSelected)}
          >
            {formik.values.contactName}
          </TextField>
        </Box>
        <Box sx={{ width: '100%' }}>
          <FormLabel sx={{ marginBottom: 0, marginTop: '20px' }}>
            Email
          </FormLabel>
          <TextField
            display='border-box'
            id='email'
            name='email'
            sx={{ marginTop: '10px', width: '95%' }}
            variant='standard'
            onChange={(e) => {
              formik.handleBlur(e)
              formik.handleChange(e)
            }}
            value={formik.values.email}
            error={formik.touched.email && Boolean(formik.errors.email)}
            helperText={formik.touched.email && formik.errors.email}
            disabled={Boolean(!updateSelected)}
          >
            {formik.values.email}
          </TextField>
        </Box>
      </Box>
      <Box
        sx={{
          display: 'flex',
          direction: 'column',
          margin: '24px 0'
        }}
      >
        <Box sx={{ width: '100%' }}>
          <FormLabel sx={{ marginBottom: 0 }}>Contact</FormLabel>
          <TextField
            variant='standard'
            id='contactNumber'
            name='contactNumber'
            sx={{ marginTop: '10px', width: '95%' }}
            onChange={(e) => {
              formik.handleBlur(e)
              formik.handleChange(e)
            }}
            value={formik.values.contactNumber}
            error={
              formik.touched.contactNumber &&
              Boolean(formik.errors.contactNumber)
            }
            helperText={
              formik.touched.contactNumber && formik.errors.contactNumber
            }
            disabled={Boolean(!updateSelected)}
          >
            {formik.values.contactNumber}
          </TextField>
        </Box>
        <Box
          sx={{
            width: '100%'
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column'
            }}
          >
            <FormLabel sx={{ marginBottom: 0 }}>Role</FormLabel>
            <Select
              name='role'
              value={formik.values.role || ''}
              onChange={handleRoleChange}
              disabled={Boolean(!updateSelected)}
              sx={{ paddingTop: '1px', marginTop: '15px', width: '95%' }}
            >
              {(formik.values.role === 'owner' || formik.values.role === 'admin'
                ? CUSTOMER_ROLE_OPTIONS
                : OPS_ROLE_OPTIONS
              ).map((option, index) => (
                <MenuItem key={index} value={option}>
                  {option}
                </MenuItem>
              ))}
            </Select>
          </Box>
        </Box>
      </Box>
      <Box>
        <Box
          sx={{
            width: '50%'
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column'
            }}
          >
            <FormLabel sx={{ marginBottom: 0 }}>Vendor</FormLabel>
            <Select
              name='vendor'
              value={formik.values.vendor || ''}
              onChange={handleVendorChange}
              disabled={
                formik.values.role != 'external' || Boolean(!updateSelected)
              }
              sx={{ paddingTop: '1px', marginTop: '15px', width: '95%' }}
            >
              {(formik.values.role === 'external'
                ? EXTERNAL_VENDOR_OPTIONS
                : ['']
              ).map((option, index) => (
                <MenuItem key={index} value={option}>
                  {option}
                </MenuItem>
              ))}
            </Select>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

AccountForm.propTypes = {
  formik: PropTypes.object,
  updateSelected: PropTypes.bool
}
